export const getErrorStatus = (err: unknown): number | undefined => {
  const e = err as { response?: { status?: number }; status?: number } | null | undefined;
  return e?.response?.status || e?.status;
};
